// Visual only, as in Gaia's markup. Not an <hr>: VUD's unlayered hr rule would override the Gaia separator style
export const MenuSeparator = () => {
    return <div className="ga-menu__separator"/>;
}
